import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const createDefaultUser = () => ({
  nome_membro: '',
  token: null,
  id_membro: null,
  id_setor: '',
  id_regional: '',
  id_cidade: ''
});

const clearStoredAppData = () => {
  const ownedKeys = ['token', 'userData', 'confirmacoes', 'setor', 'theme'];

  ownedKeys.forEach(key => localStorage.removeItem(key));

  Object.keys(localStorage)
    .filter(key => key.startsWith('app/'))
    .forEach(key => localStorage.removeItem(key));
};

export default new Vuex.Store({
  state: {
    android: false,
    id_regional: '',
    theme: 0,
    resolvedTheme: 2,
    user: createDefaultUser(),
    dados: { regional: {}, setores: [] },
    notificacoes: [],
    calendario: { datas: [], ano: '', id_setor: '' },
    listas: [],
    meses: [
      {"mes": "Janeiro", "valor": 1},
      {"mes": "Fevereiro", "valor": 2},
      {"mes": "Março", "valor": 3},
      {"mes": "Abril", "valor": 4},
      {"mes": "Maio", "valor": 5},
      {"mes": "Junho", "valor": 6},
      {"mes": "Julho", "valor": 7},
      {"mes": "Agosto", "valor": 8},
      {"mes": "Setembro", "valor": 9},
      {"mes": "Outubro", "valor": 10},
      {"mes": "Novembro", "valor": 11},
      {"mes": "Dezembro", "valor": 12}
    ]
  },

  mutations: {
    setDadosApp: (state, data) => {
      state.dados = data;
    },

    setDataUser: (state, data) => {
      localStorage.setItem('token', data.token);
      localStorage.setItem('userData', JSON.stringify(data));
      state.id_regional = data.id_regional || null
      state.user = data;
    },

    setRegionalId: (state, id_regional) => {
      state.id_regional = id_regional || null;
      state.user = {
        ...state.user,
        id_regional: id_regional || null
      };
    },

    setNotificacoes: (state, notificacoes) => {
      state.notificacoes = notificacoes;
    },

    setTheme: (state, theme) => {
      state.theme = theme;
    },

    setResolvedTheme: (state, theme) => {
      state.resolvedTheme = theme;
    },

    setCalendario: (state, calendario) => {
      state.calendario = calendario;
    },

    setListas: (state, listas) => {
      state.listas = listas;
    },

    logout(state) {
      clearStoredAppData();
      state.id_regional = null;
      state.user = createDefaultUser();
      state.dados = { regional: {}, setores: [] };
      state.notificacoes = [];
      state.calendario = { datas: [], ano: '', id_setor: '' };
      state.listas = [];
    }
  },

  actions: {
  },

  modules: {
  }
})
